export const vulnerabilityPolicyColumns = [
  "vulnerabilityLevel",
  "importanceLevelCd",
  "weaknessCd",
  "level",
  "levelCode",
  "useFlag",
  "followupContent",
];

export const columnDisplayNames = {
  vulnerabilityLevel: "vulnerability-policy.vulnerability-level",
  importanceLevelCd: "vulnerability-policy.importance-level-cd",
  weaknessCd: "vulnerability-policy.weakness-cd",
  level: "vulnerability-policy.level",
  levelCode: "vulnerability-policy.level-code",
  useFlag: "vulnerability-policy.use-flag",
  followupContent: "vulnerability-policy.followup-content",
};

export const assetClassificationColumns = ["assetImportanceLevel", "remark"];

export const assetClassificationColumnDisplayNames = {
  assetImportanceLevel: "vulnerability-policy.asset-importance-level",
  remark: "common.remark",
};

export const importanceLevels = ["HIGHEST", "HIGH", "MEDIUM", "LOW"];

export const severityLevels = ["CRITICAL", "HIGH", "MEDIUM", "LOW"];

export const cellStyles = {
  HIGHEST_CRITICAL: { backgroundColor: "#8B0000" },
  HIGHEST_HIGH: { backgroundColor: "#FF0000" },
  HIGHEST_MEDIUM: { backgroundColor: "#4682B4" },
  HIGHEST_LOW: { backgroundColor: "#FFA500" },
  HIGH_CRITICAL: { backgroundColor: "#FF0000" },
  HIGH_HIGH: { backgroundColor: "#FF0000" },
  HIGH_MEDIUM: { backgroundColor: "#4682B4" },
  HIGH_LOW: { backgroundColor: "#FFA500" },
  MEDIUM_CRITICAL: { backgroundColor: "#4682B4" },
  MEDIUM_HIGH: { backgroundColor: "#4682B4" },
  MEDIUM_MEDIUM: { backgroundColor: "#4682B4" },
  MEDIUM_LOW: { backgroundColor: "#FFA500" },
  LOW_CRITICAL: { backgroundColor: "#FFA500" },
  LOW_HIGH: { backgroundColor: "#FFA500" },
  LOW_MEDIUM: { backgroundColor: "#FFA500" },
  LOW_LOW: { backgroundColor: "#FFA500" },
};

export const cellLabels = {
  HIGHEST_CRITICAL: {
    label: "S",
    vulnerabilityLevel: "1",
    vulnerabilityLevelCode: "S",
    fulfillmentContent: "Remove or Use another components",
  },
  HIGHEST_HIGH: {
    label: "A",
    vulnerabilityLevel: "2",
    vulnerabilityLevelCode: "A",
    fulfillmentContent: "Emergency Patch Required",
  },
  HIGHEST_MEDIUM: {
    label: "D",
    vulnerabilityLevel: "3",
    vulnerabilityLevelCode: "D",
    fulfillmentContent: "Patch Recommandation",
  },
  HIGHEST_LOW: {
    label: "I",
    vulnerabilityLevel: "4",
    vulnerabilityLevelCode: "I",
    fulfillmentContent: "Periodic Monitoring Required",
  },

  HIGH_CRITICAL: {
    label: "B",
    vulnerabilityLevel: "2",
    vulnerabilityLevelCode: "B",
    fulfillmentContent: "Emergency Patch Required",
  },
  HIGH_HIGH: {
    label: "C",
    vulnerabilityLevel: "2",
    vulnerabilityLevelCode: "C",
    fulfillmentContent: "Emergency Patch Required",
  },
  HIGH_MEDIUM: {
    label: "E",
    vulnerabilityLevel: "3",
    vulnerabilityLevelCode: "E",
    fulfillmentContent: "Patch Recommandation",
  },
  HIGH_LOW: {
    label: "J",
    vulnerabilityLevel: "4",
    vulnerabilityLevelCode: "J",
    fulfillmentContent: "Periodic Monitoring Required",
  },

  MEDIUM_CRITICAL: {
    label: "F",
    vulnerabilityLevel: "3",
    vulnerabilityLevelCode: "F",
    fulfillmentContent: "Patch Recommandation",
  },
  MEDIUM_HIGH: {
    label: "G",
    vulnerabilityLevel: "3",
    vulnerabilityLevelCode: "G",
    fulfillmentContent: "Patch Recommandation",
  },
  MEDIUM_MEDIUM: {
    label: "H",
    vulnerabilityLevel: "3",
    vulnerabilityLevelCode: "H",
    fulfillmentContent: "Patch Recommandation",
  },
  MEDIUM_LOW: {
    label: "M",
    vulnerabilityLevel: "4",
    vulnerabilityLevelCode: "M",
    fulfillmentContent: "Periodic Monitoring Required",
  },

  LOW_CRITICAL: {
    label: "K",
    vulnerabilityLevel: "4",
    vulnerabilityLevelCode: "K",
    fulfillmentContent: "Periodic Monitoring Required",
  },
  LOW_HIGH: {
    label: "L",
    vulnerabilityLevel: "4",
    vulnerabilityLevelCode: "L",
    fulfillmentContent: "Periodic Monitoring Required",
  },
  LOW_MEDIUM: {
    label: "N",
    vulnerabilityLevel: "4",
    vulnerabilityLevelCode: "N",
    fulfillmentContent: "Periodic Monitoring Required",
  },
  LOW_LOW: {
    label: "O",
    vulnerabilityLevel: "4",
    vulnerabilityLevelCode: "O",
    fulfillmentContent: "Periodic Monitoring Required",
  },
};
